<div class="single-period-container">
  <div class="period-header" [style.backgroundColor]="isToday ? 'var(--lightGreen)' : 'var(--comunicareSecondary)'">
    <span class="period-date">{{ isToday ? ("drugSchema.today" | translate) : (date | safeDate : "dd/MM/yyyy") }}</span>
  </div>
  <div class="period-content">
    <div class="observations-horizontal">
      <div *ngFor="let observation of observations" class="observation-item">
        <app-observation-values-display [observation]="observation"></app-observation-values-display>
      </div>
    </div>
    <div *ngIf="!observations || observations.length === 0" class="no-data">{{ "widget.noData" | translate }}</div>
  </div>
</div>
